import React, { Component } from 'react';

import Page from './Page';


class PageContainer extends Component {
  constructor(props){
    super(props);
    this.state = {};
  }
  render() {
    const {
      activePage,
      pageElements,
      needPrev,
      needNext,
      handlePrev,
      handleNext,
      handlePageChange
    } = this.props;
    return (
      <ul className="page-wrap">
        {needPrev ? 
          (<li className="nav-item page icon prev"
                onClick={handlePrev}></li>)
          : null
        }
        {pageElements.map((page) => {
          const isActive = page.num === activePage;
          return (
            <Page num={page.num} isActive={isActive} key={page.num}
                  handleOnClick={handlePageChange}/>
          )
        })}
        {needNext ? 
          (<li className="nav-item page icon next"
                onClick={handleNext}></li>)
          : null
        }
      </ul>
    );
  }
}

export default PageContainer;


// WEBPACK FOOTER //
// ./src/components/pagination/PageContainer.js